import type { Component, Entity2D } from '../../odie';

import type { ColorId, CurtainBlockProps } from '../defs/block';
import { blockOptionFromCountSize } from '../util/blockOption';
import { CurtainBlockView } from '../views/blocks/CurtainBlockView';

// types
//-----------------------------------------------------------------------------
export type CurtainBlockComponentOptions = {
  props: CurtainBlockProps;
  option?: number;
};

/*
  Curtain block component
*/
export class CurtainBlockComponent implements Component {
  public static readonly NAME = 'blockCurtain';

  public get counter(): number {
    return this._counter;
  }
  public set counter(value: number) {
    value = Math.max(0, value);
    this._counter = value;
    this.view.updateCounter(value);
  }

  public get color(): ColorId {
    return this._color;
  }

  public set color(value: ColorId) {
    this._color = value;
    this.view.updateColor(value);
  }

  public get props(): CurtainBlockProps {
    return this.options.props;
  }

  public entity!: Entity2D;
  public view!: CurtainBlockView;
  private _counter!: number;
  private _color!: ColorId;
  private options!: CurtainBlockComponentOptions;

  public init(options: CurtainBlockComponentOptions): void {
    this.view = new CurtainBlockView(options.props);
    this.options = options;
    this.color = options.props.color;
    this.counter = options.props.count;
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState() {
    // Convert block count & size into a single number to be used as a gameplay state
    return blockOptionFromCountSize({
      count: this.counter,
      width: this.props.width,
      height: this.props.height,
    });
  }
}
